<script setup lang="ts">
import { computed } from 'vue'
import { useThemeStore } from '@clevver/stores/theme.store'
const theme = useThemeStore()
// White wordmark on dark, navy wordmark on light — both horizontal.
const src = computed(() => theme.mode === 'dark' ? '/images/logo-horizontal.svg' : '/images/logo-horizontal-blue.svg')
</script>

<template>
  <div class="app-sidebar-logo">
    <router-link :to="{ name: 'home', query: {} }">
      <img :src="src" alt="Clevver" class="dashboard-logo" />
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.dashboard-logo { height: 30px; display: block; }
</style>
